import React from 'react'

const AddUser = (props) => (
    <svg width="19" height="14" viewBox="0 0 19 14" fill={props.color ? props.color : '#FFFFFF'}
         xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M9.5 3.73333C9.5 5.7952 7.79868 7.46667 5.7 7.46667C3.60132 7.46667 1.9 5.7952 1.9 3.73333C1.9 1.67147 3.60132 0 5.7 0C7.79868 0 9.5 1.67147 9.5 3.73333ZM7.6 3.73333C7.6 4.76427 6.74934 5.6 5.7 5.6C4.65066 5.6 3.8 4.76427 3.8 3.73333C3.8 2.7024 4.65066 1.86667 5.7 1.86667C6.74934 1.86667 7.6 2.7024 7.6 3.73333Z"
        />
        <path d="M14.25 3.73333H16.15V6.53333H19V8.4H16.15V11.2H14.25V8.4H11.4V6.53333H14.25V3.73333Z"/>
        <path
            d="M9.5 14H11.4C11.4 10.9072 8.84802 8.4 5.7 8.4C2.55198 8.4 0 10.9072 0 14H1.9C1.9 11.9381 3.60132 10.2667 5.7 10.2667C7.79868 10.2667 9.5 11.9381 9.5 14Z"
        />
    </svg>
)

export default AddUser
